import styled, { css } from 'styled-components'
import {
    svgStroke, flashKeyframes,
    fromPhone, belowPhone
} from 'utilities/styled'
import { compact } from 'utilities/array'
import { Grid } from 'components/grid'
import { Plain } from 'components/button'
import SymbolBase from 'components/symbol'
import { ancestorHover } from 'components/symbol/s'
import { InlineMessage } from 'components/message'
import ExpiryStatusBase from 'components/expiry-status'

export const pieceGrid = css`
    grid-template-columns: minmax(0, 2fr) minmax(0, 2fr) 1fr 40px;
`

export const PieceWrapper = styled(Grid)`
    ${pieceGrid}
    column-gap: 24px;

    width: 100%;
    padding-block: 24px;
    box-shadow: 0 -1px var(--huma-color-border-default);

    &.flash {
        animation: ${flashKeyframes} 2s ease-in-out;
    }

    ${({ theme: { equipment: { variant } } }) => belowPhone`
        grid-template-columns: 1fr 40px;
        grid-template-rows: ${compact(['40px', variant && '20px', 'auto']).join(' ')};
        grid-auto-rows: auto;
        row-gap: 8px;
    `}
`

const equipmentCellCss = css`
    display: grid;
    grid-template-columns: 40px minmax(0, 1fr);
    column-gap: 16px;
    align-items: center;

    height: 40px;

    text-align: start;
`

export const EquipmentCellClickable = styled(Plain)`
    ${equipmentCellCss}

    &:is(
        :not(:disabled):hover,
        :not(:disabled):focus
    ) {
        text-decoration: none;

        > span {
            text-decoration: underline;
        }
    }

    ${belowPhone`
        grid-row: 1 / 2;
    `}
`

export const EquipmentCellWrapper = styled.div`
    ${equipmentCellCss}
`

export const Symbol = styled(SymbolBase)`
    ${ancestorHover(EquipmentCellClickable)}
`

export const EquipmentTitle = styled.div``

export const EquipmentMessage = styled(InlineMessage)`
    & p {
        line-height: 20px;
    }
`

const cellCss = css`
    display: grid;
    align-items: start;

    padding-block: 8px;
`

export const VariantCell = styled.div`
    ${cellCss}

    color: var(--huma-color-foreground-subtle);

    ${fromPhone`
        line-height: 24px;
    `}

    ${belowPhone`
        grid-column: 1 / 2;
        grid-row: 2 / 3;
        grid-template-columns: auto 1fr;
        align-items: center;

        padding-inline-start: 56px;

        font-size: 14px;
    `}
`

export const StatusCell = styled.div`
    ${cellCss}

    & > :last-child {
        margin-block-end: 0;
    }
    ${fromPhone`
        & > :first-child {
            margin-block-start: 4px;
        }
    `}

    ${belowPhone`
        grid-column: 1 / 2;

        ${({ theme: { equipment: { variant } } }) => {
            if(variant) {
                return css`
                    grid-row: 3 / 4;
                `
            }

            return css`
                grid-row: 2 / 4;
            `
        }}

        padding-inline-start: 56px;

        &:empty {
            display: none;
        }
    `}
`

export const ExpiryStatus = styled(ExpiryStatusBase)`
    align-items: center;

    & p {
        line-height: 20px;
    }
`

export const ActionsCell = styled.div`
    justify-content: center;

    ${belowPhone`
        grid-column: 2 / 3;
        grid-row: 1 / 2;
    `}

    svg {
        ${svgStroke()}
    }
`
